import { render, staticRenderFns } from "./VisibilitySettingsModal.vue?vue&type=template&id=877554b8"
import script from "./VisibilitySettingsModal.vue?vue&type=script&lang=js"
export * from "./VisibilitySettingsModal.vue?vue&type=script&lang=js"
import style0 from "./VisibilitySettingsModal.vue?vue&type=style&index=0&id=877554b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports